<template>
  <div class="package-detail-wrapper">
    <div class="package-detail-doctor">
      <div class="package-detail-doctor-info">
        <div class="package-detail-doctor-info-left">
          <span class="package-detail-doctor-info-name">
            {{ doctorInfo.name }}
          </span>
          <span class="package-detail-doctor-info-department">
            {{ doctorInfo.department }}
          </span>
          <span class="package-detail-doctor-info-title">
            {{ doctorInfo.title }}
          </span>
          <div class="package-detail-doctor-info-hosipital">
            <div
              v-show="doctorInfo.is_3a_hospital"
              class="package-detail-doctor-info-hosipital-tag"
            >
              三甲
            </div>
            <span class="package-detail-doctor-info-hosipital-name">
              {{ doctorInfo.hospital_name }}
            </span>
          </div>
        </div>
        <img
          :src="doctorInfo.avatar"
          class="package-detail-doctor-info-avatar"
        />
        <img
          src="https://resource.chunyu.mobi/@/media/images/2022/08/22/e4a7/fe3a9aa576ee_w195_h195_.png"
          alt=""
          class="package-detail-doctor-info-avatar-border"
        />
      </div>
      <div class="split" />
      <div class="package-detail-doctor-intro">
        欢迎购买我的优惠套餐，复诊更方便
      </div>
    </div>
    <div class="package-detail-list">
      <div
        v-for="item in packageList"
        :key="item.package_id"
        class="package-dtail-list-item"
      >
        <div class="package-dtail-list-item-info-wrapper">
          <span class="package-dtail-list-item-title">{{ item.title }}</span>
          <span class="package-dtail-list-item-sub_title">{{
            item.sub_title
          }}</span>
        </div>
        <span
          class="package-dtail-list-item-price_str"
          :class="packageList.length <= 1 ? 'right15' : ''"
          >{{ item.price_str }}</span
        >
        <span class="package-dtail-list-item-desc">{{ item.desc }}</span>
        <img
          src="https://resource.chunyu.mobi/@/media/images/2024/04/15/1640/07bbee245c89_w210_h60_.png"
          alt=""
          class="package-dtail-list-item-icon"
          :class="packageList.length <= 1 ? 'right10' : ''"
        />
        <div v-if="packageList.length > 1" class="package-dtail-list-item-sele">
          <div
            v-if="!item.selected"
            class="pass-checkbox"
            @click="handleSelect(item)"
          />
          <img
            v-else
            src="https://resource.chunyu.mobi/@/media/images/2024/04/22/6455/4a9950d1fd51_w60_h60_.png"
            alt=""
            class="pass-select"
          />
        </div>
      </div>
    </div>
    <div class="package-detail-rule">
      <span class="package-detail-rule-title">
        服务规则
      </span>
      <span class="package-detail-rule-content" v-html="service_rule" />
    </div>
    <div v-if="had_package" class="package-detail-tips" @click="toList">
      提醒：您还未使用完该咨询师的套餐服务，去查看>>
    </div>
    <div class="package-detail-buy">
      <div class="package-detail-buy-button" @click="goBuy">
        立即购买
      </div>
    </div>
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import { getDoctorPackageDetail } from '@/services/index';
import cyShare from '@cy/share';
import { doPoint } from '@/utils/index.js';

const wx = require('weixin-js-sdk');

export default {
  data() {
    return {
      doctorInfo: {},
      packageList: [],
      service_rule: '',
      had_package: true, // 剩余已购买套餐包
      package_id: '', // 选中的packageid
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取套餐详情
     */
    getData() {
      console.log(this.$route, 'router');
      const params = {
        doctor_id: this.$route.query.doctor_id,
      };
      getDoctorPackageDetail(params).then(resp => {
        console.log(resp);
        this.doctorInfo = resp.doctor_info;
        this.packageList = resp.package_list;
        this.service_rule = resp.service_rule;
        this.had_package = resp.had_package;
        this.packageList[0].selected = true;
        document.title = `${this.doctorInfo.name}咨询师的套餐`;
        this.setShareInfo();
        doPoint('PageView', {
          app: cyDetect.isFromWechat() ? 'weixin_mini' : 0,
          page_title: document.title,
          page_readable_name: '套餐介绍页',
        });
      });
    },
    /**
     * 选中套餐
     *
     * @param item
     */
    handleSelect(item) {
      this.packageList.forEach(data => {
        data.selected = false;
      });
      item.selected = true;
      this.package_id = item.package_id;
      this.$forceUpdate();
      console.log(this.packageList, 'pa');
    },
    /**
     * 我的套餐
     */
    toList() {
      window.location.href = '/v-m-general/my-package';
    },
    /**
     * 立即购买
     */
    goBuy() {
      const payData = {
        type: 'benefit_package',
        info: {
          content_str: '',
          doctor_id: this.$route.query.doctor_id,
          benefit_package_id: this.package_id || this.packageList[0].package_id,
          type: 2,
          ...(cyDetect.isFromWechat() && {
            partner: 'chunyu_wap_mini',
          }),
        },
      };
      const infoStr = encodeURIComponent(JSON.stringify(payData.info));
      if (cyDetect.isFromWechat()) {
        wx.miniProgram.navigateTo({
          url: `/pages/payment/index?info=${infoStr}&type=benefit_package&mark=benefit_package`,
        });
      } else if (cyDetect.isFromCY()) {
        window.location.href = `/weixin/pay/?info=${infoStr}&type=benefit_package&pay_version=2`;
      }
    },
    /**
     * 设置分享信息
     */
    setShareInfo() {
      const url = window.location.href;
      const shareInfo = {
        title: document.title,
        userName: 'gh_681d3fd5683f',
        mini_id: 'gh_681d3fd5683f',
        link: url,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2024/04/22/2db4/8b1db79d97d8_w630_h504_.png',
        wx_scene_timeline_desc: '春雨医生',
      };
      cyShare.app(shareInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.right15 {
  right: rem(18) !important;
}
.right10 {
  right: rem(10) !important;
}
.package-detail-wrapper {
  height: 100vh;
  padding: rem(10);
  background: rgb(247, 247, 247);
  .package-detail-doctor {
    position: relative;
    width: rem(355);
    height: rem(125);
    padding: rem(11) rem(15) rem(5) rem(15);
    background: #fff;
    border-radius: rem(4);
    .package-detail-doctor-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .package-detail-doctor-info-left {
      color: #323232;
      font-size: rem(13);
      .package-detail-doctor-info-name {
        color: #323232;
        font-weight: bold;
        font-size: rem(22);
      }
      .package-detail-doctor-info-department {
        margin: 0 rem(6);
      }
    }
    .package-detail-doctor-info-hosipital {
      display: flex;
      margin-top: rem(9);
      .package-detail-doctor-info-hosipital-tag {
        width: rem(32);
        height: rem(16);
        margin-right: rem(5);
        color: #fff;
        font-size: rem(12);
        line-height: rem(16);
        text-align: center;
        background: #1cc381;
        border-radius: rem(2);
      }
    }
    .package-detail-doctor-info-avatar {
      width: rem(65);
      height: rem(65);
      border-radius: 50%;
    }
    .package-detail-doctor-info-avatar-border {
      position: absolute;
      top: rem(11);
      right: rem(14);
      z-index: 1;
      width: rem(67);
      height: rem(67);
    }
  }
  .split {
    width: rem(325);
    height: 1px;
    margin-top: rem(11);
    background: #e7e7e7;
    transform: scaleY(0.5);
  }
  .package-detail-doctor-intro {
    margin-top: rem(9.5);
    color: #323232;
    font-size: rem(13);
  }
  .package-detail-list {
    margin-top: rem(10);
    .package-dtail-list-item {
      position: relative;
      width: rem(355);
      height: rem(101);
      margin-bottom: rem(10);
      background: url('https://resource.chunyu.mobi/@/media/images/2024/04/15/daa0/cd226307f782_w1065_h303_.png');
      background-size: contain;
      .package-dtail-list-item-info-wrapper {
        position: absolute;
        top: rem(45);
        left: rem(15);
      }
      .package-dtail-list-item-title {
        color: #323232;
        font-weight: bold;
        font-size: rem(15);
      }
      .package-dtail-list-item-sub_title {
        margin-left: rem(8);
        color: #666;
        font-size: 13px;
      }
      .package-dtail-list-item-price_str {
        position: absolute;
        top: rem(46);
        right: rem(50);
        color: #ff6134;
        font-size: rem(16);
      }
      .package-dtail-list-item-desc {
        position: absolute;
        bottom: rem(12);
        left: rem(15);
        color: #666;
        font-size: rem(13);
      }
      .package-dtail-list-item-icon {
        position: absolute;
        top: rem(20);
        right: rem(40);
        width: rem(70);
        height: rem(20);
      }
      .pass-checkbox {
        position: absolute;
        top: rem(50);
        right: rem(15);
        width: rem(20);
        height: rem(20);
        border: 1px solid rgba(216, 216, 216, 1);
        border-radius: 50%;
      }
      .pass-select {
        position: absolute;
        top: rem(50);
        right: rem(15);
        width: rem(20);
        height: rem(20);
      }
    }
  }
  .package-detail-rule {
    width: rem(355);
    margin-top: rem(12);
    padding: rem(15);
    background: #fff;
    border-radius: rem(4);
    .package-detail-rule-title {
      display: block;
      margin-bottom: rem(15);
      color: #323232;
      font-weight: bold;
      font-size: rem(15);
    }
    .package-detail-rule-content {
      color: #666;
      font-size: rem(13);
    }
  }
  .package-detail-tips {
    position: fixed;
    bottom: rem(98);
    left: 0;
    width: 100%;
    height: rem(35);
    padding-left: rem(15);
    color: #fe601e;
    font-size: rem(13);
    line-height: rem(35);
    background-image: linear-gradient(
      90deg,
      rgba(255, 226, 214, 0.97) 0%,
      #fff4f0 100%
    );
  }
  .package-detail-buy {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: rem(98);
    background: #fff;
    .package-detail-buy-button {
      width: rem(345);
      height: rem(44);
      margin: rem(10) rem(15);
      color: #fff;
      font-weight: bold;
      line-height: rem(44);
      text-align: center;
      background: #39d167;
      border-radius: 2px;
    }
  }
}
</style>
